"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readMetadata = readMetadata;
exports.readSelectList = readSelectList;
exports.readSubForm = readSubForm;
exports.readParseDate = readParseDate;
var core_api_1 = require("@ikegps/core-api");
var index_1 = require("../index");
function readMetadata(target, metadata) {
    if (metadata == null) {
        return;
    }
    if (metadata.import != null) {
        target.metadata.setImportType(metadata.import.type, metadata.import.version);
    }
    if (metadata.status != null) {
        var statusField = target.getField(metadata.status.field);
        if (statusField == null || !(statusField.type === core_api_1.IkeFieldType.NESTED_LIST || statusField.type === core_api_1.IkeFieldType.SELECT_LIST)) {
            throw new Error('Unable to find status field for form: ' + target.revision + ' status:' + metadata.status.field);
        }
        target.metadata.setStatusField(statusField);
    }
    if (metadata.mapColor != null) {
        var mapColorField = target.getField(metadata.mapColor.field);
        if (mapColorField == null || !(mapColorField.type === core_api_1.IkeFieldType.NESTED_LIST || mapColorField.type === core_api_1.IkeFieldType.SELECT_LIST)) {
            throw new Error('Unable to find status field for form: ' + target.revision + ' mapColor:' + metadata.mapColor.field);
        }
        target.metadata.setMapColorField(mapColorField);
    }
    Object.keys(metadata).forEach(function (key) {
        if (key === 'import' || key === 'status' || key === 'mapColor') {
            return;
        }
        target.metadata.setOption(key, metadata[key]);
    });
}
function getProviders(field) {
    var providers = [];
    // No valid providers nothing to serialize
    if (field.providers == null || field.providers.length === 0) {
        return undefined;
    }
    // Convert all string providers to their respective object mode
    for (var _i = 0, _a = field.providers; _i < _a.length; _i++) {
        var provider = _a[_i];
        if (typeof provider !== 'string') {
            providers.push(provider);
            continue;
        }
        // Default provider object for existing span
        if (provider === core_api_1.IkeProviderType.EXISTING_SPAN) {
            providers.push(index_1.IkeCalcExistingSpanLegacyProvider);
        }
    }
    if (providers.length === 0) {
        return undefined;
    }
    return providers;
}
function readSelectList(target, field) {
    if (field.options == null || !Array.isArray(field.options)) {
        return;
    }
    for (var i = 0; i < field.options.length; i++) {
        var opt = field.options[i];
        target.Mutator.option(opt, i);
    }
}
function readSubForm(target, fields, allFields) {
    if (allFields === void 0) { allFields = {}; }
    for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
        var field = fields_1[_i];
        /** Sometimes we get duplicate fieldIds these are not valid and need to be removed. */
        if (allFields[field.name]) {
            continue;
        }
        var targetField = target.createField(field.type, {
            id: field.name,
            displayName: field.displayname,
            cloneable: field.cloneable,
            title: field.title,
            subtitle: field.subtitle,
            adminOnly: field.adminOnly,
            annotationLabelFieldId: field.annotationLabelFieldId,
            clearanceThresholdInMeters: field.clearanceThresholdInMeters,
            providers: getProviders(field),
            collector: field.collector,
            required: field.required
        });
        allFields[field.name] = true;
        if (index_1.FormModelFieldSubForm.isSubForm(targetField)) {
            var schema = field.schema;
            if (schema == null) {
                continue;
            }
            targetField.Mutator.label(schema.label);
            if (!Array.isArray(schema.fields)) {
                continue;
            }
            readSubForm(targetField, schema.fields, allFields);
        }
        else if (index_1.FormModelFieldNestedList.isNestedList(targetField)) {
            targetField.Mutator.init(field.options);
        }
        else if (index_1.FormModelFieldSelectList.isSelectList(targetField)) {
            readSelectList(targetField, field);
        }
    }
    return null;
}
function readParseDate(isoString) {
    if (isoString == null) {
        return null;
    }
    return new Date(isoString);
}
//# sourceMappingURL=db.v1.read.js.map